import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab, Typography, Stack } from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Business as BusinessIcon,
  ReceiptLong as LedgerIcon,
  Inbox as UnmatchedIcon,
  AccountBalance as LenderIcon,
} from '@mui/icons-material';

const TABS = [
  { label: 'Overview', path: '/sales/funded', icon: <DashboardIcon fontSize="small" /> },
  { label: 'Clients', path: '/sales/funded/clients', icon: <BusinessIcon fontSize="small" /> },
  { label: 'Fundings & Commissions', path: '/sales/funded/ledger', icon: <LedgerIcon fontSize="small" /> },
  { label: 'Unmatched', path: '/sales/funded/unmatched', icon: <UnmatchedIcon fontSize="small" /> },
  { label: 'Lenders', path: '/sales/funded/lenders', icon: <LenderIcon fontSize="small" /> },
];

// Section header + tab navigation shared across all funded-book pages.
export default function FundedNav({ title, subtitle, actions }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Highlight the best matching tab (longest path prefix).
  const active = TABS.reduce((best, t) => {
    if (location.pathname === t.path) return t.path;
    if (location.pathname.startsWith(t.path) && t.path !== '/sales/funded' && (!best || t.path.length > best.length)) return t.path;
    return best;
  }, location.pathname === '/sales/funded' ? '/sales/funded' : '');

  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 1 }}>
        <Box>
          <Typography variant="h5" fontWeight={800} color="#0d2137">{title || 'Funded Book'}</Typography>
          {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
        </Box>
        {actions}
      </Stack>
      <Tabs
        value={active || false}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider', minHeight: 40 }}
      >
        {TABS.map((t) => (
          <Tab
            key={t.path}
            value={t.path}
            label={t.label}
            icon={t.icon}
            iconPosition="start"
            onClick={() => navigate(t.path)}
            sx={{ minHeight: 40, textTransform: 'none', fontWeight: 600, fontSize: '0.8rem' }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
